import { cols } from "@/config/system";

import { momentFormat } from "@/utils/formatter";

export const tableColumn = [
  {
    type: "index",
    label: "序号",
    fixed: "left",
    disabled: true,
    width: cols.number,
  },
  {
    label: "运单号",
    prop: "billCode",
    slotName: "billCode",
    width: cols.op3,
  },
  {
    label: "结算日期",
    prop: "billDate",
    width: cols.op2,
    formatter: (row: any, column: any, cellValue: string) =>
      momentFormat(cellValue, "YYYY-MM-DD"),
  },
  {
    label: "扫描时间",
    prop: "scanTime",
    width: cols.op2,
    formatter: (row: any, column: any, cellValue: string) =>
      momentFormat(cellValue, "YYYY-MM-DD hh:mm:ss"),
  },
  {
    label: "结算客户",
    prop: "accountUserName",
  },
  {
    label: "项目客户",
    prop: "contractProjectName",
  },
  {
    label: "结算客户编码",
    prop: "accountUserCode",
  },
  {
    label: "业务员",
    prop: "scanUserName",
  },
  {
    label: "网点名称",
    prop: "siteName",
  },
  {
    label: "合同主体",
    prop: "contractSubject",
  },
  {
    label: "客户",
    prop: "customerName",
  },
  {
    label: "结算重量",
    prop: "accountWeight",
  },
  {
    label: "班次类型",
    prop: "classTypeName",
  },
  {
    label: "物品类型",
    prop: "goodsTypeName",
  },
  {
    label: "目的地省",
    prop: "dispProvName",
  },
  {
    label: "目的地城市",
    prop: "dispCityName",
  },
  {
    label: "增值类型",
    prop: "valueAddedTypeName",
  },
  {
    label: "产品类型",
    prop: "productName",
  },
  {
    label: "面单类型",
    prop: "billType",
    formatter: (row: any, column: any, cellValue: string) => row.trBillType,
  },
  {
    label: "面单费",
    prop: "szBillFee",
  },
  {
    label: "运费合计",
    prop: "toAccountFee",
  },
  {
    label: "运费",
    prop: "avgWeightFee",
  },
  {
    label: "附加费",
    prop: "operAddFee",
  },
  {
    label: "增值加收费",
    prop: "valueAddedFee",
  },
  {
    label: "均票区间费",
    prop: "avgTicketFee",
  },
  {
    label: "折扣/加收费用",
    prop: "totalTieredPlus",
  },
  {
    label: "运单发放客户",
    prop: "billProvideManName",
  },
  {
    label: "签收状态",
    prop: "signStatus",
    formatter: (row: any, column: any, cellValue: string) => row.trSignStatus,
  },
  {
    label: "签收时间",
    prop: "signTime",
    formatter: (row: any, column: any, cellValue: string) =>
      momentFormat(cellValue, "YYYY-MM-DD hh:mm:ss"),
  },
  {
    label: "是否退件",
    prop: "returnStatus",
    formatter: (row: any, column: any, cellValue: string) => row.trReturnStatus,
  },
  {
    label: "是否问题件",
    prop: "problemPiecesType",
    formatter: (row: any, column: any, cellValue: string) =>
      row.trProblemPiecesType,
  },
  {
    label: "订单编号",
    prop: "orderCode",
  },
  {
    label: "交易号",
    prop: "partnerTradeId",
  },
  {
    label: "订单渠道",
    prop: "orderSource",
  },
  {
    label: "扫描员",
    prop: "scanName",
  },
  {
    label: "调账次数",
    prop: "customerCycleAbnormalCount",
    slotName: "times",
  },
  {
    label: "操作",
    slotName: "actions",
    fixed: "right",
    width: cols.op3,
  },
];

export const tableColumn1 = [
  {
    type: "index",
    label: "序号",
    fixed: "left",
    disabled: true,
    width: cols.number,
  },
  {
    label: "运单号",
    prop: "billCode",
    slotName: "billCode",
    width: cols.op3,
  },

  {
    label: "网点名称",
    prop: "siteName",
  },
  {
    label: "对账客户名称",
    prop: "customerName",
  },
  {
    label: "项目客户",
    prop: "contractProjectName",
  },
  {
    label: "运单发放客户",
    prop: "billProvideManName",
  },
  {
    label: "结算日期",
    prop: "billDate",
    width: cols.op2,
    formatter: (row: any, column: any, cellValue: string) =>
      momentFormat(cellValue, "YYYY-MM-DD"),
  },
  {
    label: "费用类型",
    prop: "itemName",
  },
  {
    label: "费用子类",
    prop: "dictName",
  },
  {
    label: "费用",
    prop: "fee",
  },
  {
    label: "备注",
    prop: "remark",
  },
  {
    label: "操作",
    prop: "actions",
    slotName: "actions",
    fixed: "right",
    width: cols.op3,
  },
];

export const tableColumn2 = [
  {
    type: "index",
    label: "序号",
    fixed: "left",
    disabled: true,
    width: cols.number,
  },
  {
    label: "运单号",
    prop: "billCode",
    slotName: "billCode",
    width: cols.op3,
  },
  {
    label: "结算日期",
    prop: "billDate",
    width: cols.op2,
    formatter: (row: any, column: any, cellValue: string) =>
      momentFormat(cellValue, "YYYY-MM-DD"),
  },

  {
    label: "网点名称",
    prop: "siteName",
  },
  {
    label: "结算重量",
    prop: "accountWeight",
  },
  {
    label: "跨期调账运费",
    prop: "crossFee",
  },
  {
    label: "项目客户",
    prop: "contractProjectName",
  },
  {
    label: "原结算客户",
    prop: "preCustomerName",
  },
  {
    label: "原结算日期",
    prop: "preBillDate",
    width: cols.op2,
    formatter: (row: any, column: any, cellValue: string) =>
      momentFormat(cellValue, "YYYY-MM-DD"),
  },
  {
    label: "原结算重量",
    prop: "preAccountWeight",
  },
  {
    label: "原运费",
    prop: "preFee",
  },
  {
    label: "调账备注",
    prop: "remark",
  },
  {
    label: "操作",
    prop: "actions",
    slotName: "actions",
    fixed: "right",
    width: cols.op3,
  },
];
